export const RouteConstant = {
    Login: 'login',
    ForgotPassword: 'forgot-password',
    ResetPassword: 'reset-password',
    PasswordUpdated:'password-updated',
    Dashboard: 'dashboard',
    EditProfile: 'edit',
    ChangePassword: 'change-password',
    Profile: 'my-profile',
    EditBlog: 'edit',
    AddBlog: 'add-blog',
    Blog:'blog',
    Client:'client',
    Customer: 'customer',
    Employee: 'employee',
    ClientProfile:'client-profile',
    CustomerProfile:'customer-profile',
    VerifyEmail: 'verifymail',
    service: 'service',
    sms: 'manage-sms',
    ManageRole: 'manage-role',
    clientSubscription: 'manage-subscription',
    invalidAttempts: 'invalidAttempts',
    coaching: 'coaching',
    settings: 'settings',
    feed: 'feed',
    meetingList: 'meeting-list',
    library: 'library',
    uploadVideo: 'upload-video',
    editVideo: 'edit-video',
    videoList: 'video-list',
    videoDetail: 'video-details',
    uploadText: 'upload-text',
    uploadImage: 'upload-image',
    subHistory: 'subscription-history',
    marketingEmails:'marketingEmails',
    distanceAPI:'distanceAPI',
    paymentHistory: 'payment-history',
    paymentProcessing: 'payment-processing',
    subscription: 'subscription',
    editPackage: 'edit-package',
    packageList: 'package-list',
    clientPayment: 'client-payment',
    emailNotification : 'email-notification',
    support: 'support',
    ticketsList: 'tickets',
    createTicket: 'create-ticket',
    archive: 'archive',
    reporting: 'reporting',
    reportsEmail: 'email-reports',
    distanceReports: 'distance-api-reports',
    smsReports: 'sms-reports',
    aiPhoneReports: 'ai-phone-agent-reports',
    superAdmin: 'super-admin-users'
}